export default {
    'bond-no': 'رقم السند',
    'entry-no': 'رقم القيد',
    'debit': 'المدين',
    'credit': 'الدائن',
    'currency-debit': 'عملة مدينة',
    'currency-credit': 'عملة دائنة',
    'currency-price': 'السعر',
    'balance': 'الرصيد',
    'currency': 'العملة',
    'date': 'التاريخ',
    'paper-document-no': 'المستند الورقي',
    'note': 'البيان',
    'matching-date': 'تاريخ المُطابقة',
}